export const blogPosts = [
  {
    id: 1,
    slug: 'university-of-philippines-overview',
    title: 'University of the Philippines: A Beacon of Excellence',
    date: '2026-01-10',
    excerpt: 'Explore the University of the Philippines system, the country\'s national university offering world-class education across multiple campuses.',
    content: `The University of the Philippines (UP) is the country's premier state university and national research institution. Established in 1908, UP has been at the forefront of Philippine higher education.

## Key Programs

- **Engineering**: Electrical, Civil, Mechanical, and Computer Engineering programs ranked among the best in Asia
- **Medicine**: UP Manila houses the top medical school in the country
- **Law**: The UP College of Law has produced many of the nation's top legal minds
- **Business Administration**: UP Diliman offers competitive MBA and undergraduate business programs
- **Sciences**: Strong programs in Biology, Chemistry, Physics, and Mathematics

## Why UP Matters

UP provides accessible quality education with relatively low tuition fees compared to private universities. The university system spans across multiple regions, making higher education accessible throughout the Philippines.`,
    author: 'Hagen-Family-Foundation',
    image: 'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=800',
    tags: ['education', 'university', 'philippines'],
  },
  {
    id: 2,
    slug: 'ateneo-de-manila-programs',
    title: 'Ateneo de Manila University: Jesuit Excellence in Education',
    date: '2026-01-08',
    excerpt: 'Discover the prestigious programs at Ateneo de Manila, known for its strong liberal arts foundation and professional programs.',
    content: `Ateneo de Manila University is one of the Philippines' most prestigious private universities, founded by Spanish Jesuits in 1859.

## Featured Programs

- **Business Management**: The John Gokongwei School of Management is renowned for producing business leaders
- **Information Technology**: Strong computer science and information systems programs
- **Communications**: Media studies and journalism programs that shape industry professionals
- **Development Studies**: Programs focused on social development and public service
- **Sciences**: Biology, Chemistry, Mathematics, and Physics with research opportunities

## The Ateneo Difference

The university emphasizes the formation of "men and women for others" - graduates who use their education to serve the community.`,
    author: 'Hagen-Family-Foundation',
    image: 'https://images.unsplash.com/photo-1562774053-701939374585?w=800',
    tags: ['education', 'university', 'private education'],
  },
  {
    id: 3,
    slug: 'de-la-salle-university',
    title: 'De La Salle University: Innovation and Research Excellence',
    date: '2026-01-05',
    excerpt: 'Learn about De La Salle University\'s cutting-edge programs in engineering, business, and the sciences.',
    content: `De La Salle University (DLSU) is a leading Philippine university known for its research output and innovative programs.

## Top Programs

- **Engineering**: Electronics, Computer, and Mechanical Engineering with modern facilities
- **Business and Economics**: The Ramon V. del Rosario College of Business is among the top in Asia
- **Computer Science**: Strong focus on AI, cybersecurity, and software development
- **Hotel and Restaurant Management**: Industry-connected hospitality education
- **Sciences**: Research-focused programs with international collaborations

## Research Focus

DLSU is known for its research centers and collaborations with international institutions, making it ideal for students interested in innovation.`,
    author: 'Hagen-Family-Foundation',
    image: 'https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?w=800',
    tags: ['education', 'research', 'innovation'],
  },
  {
    id: 4,
    slug: 'university-of-santo-tomas',
    title: 'University of Santo Tomas: Asia\'s Oldest University',
    date: '2026-01-02',
    excerpt: 'Explore the historic University of Santo Tomas, founded in 1611, and its diverse academic offerings.',
    content: `The University of Santo Tomas (UST), founded in 1611, is the oldest existing university in Asia.

## Notable Programs

- **Medicine and Allied Health**: One of the country's top medical schools
- **Pharmacy**: Highly regarded pharmaceutical sciences program
- **Architecture**: Strong design and architecture programs
- **Fine Arts**: Renowned for visual arts and design education
- **Law**: Historic law school with distinguished alumni

## Historic Significance

UST's history spans over 400 years, making it a treasure trove of Philippine academic heritage while maintaining modern relevance.`,
    author: 'Hagen-Family-Foundation',
    image: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800',
    tags: ['education', 'history', 'tradition'],
  },
  {
    id: 5,
    slug: 'leyte-normal-university',
    title: 'Leyte Normal University: Nurturing Educators in Eastern Visayas',
    date: '2025-12-28',
    excerpt: 'Discover Leyte Normal University in Tacloban City, a key institution in developing quality educators for the region.',
    content: `Leyte Normal University (LNU), located in Tacloban City, plays a crucial role in teacher education in Eastern Visayas.

## Core Programs

- **Teacher Education**: Elementary, Secondary, and Special Education programs
- **Graduate Studies**: Master's and doctoral programs in education
- **Arts and Sciences**: Liberal arts foundation for aspiring educators
- **Industrial Technology**: Technical education programs
- **Hospitality Management**: Tourism and hospitality education

## Regional Impact

LNU has been instrumental in providing quality education in a region recovering from natural disasters, producing teachers who serve communities throughout the Visayas.

This university holds special significance for the Hagen-Family-Foundation's mission, as it serves the Tacloban City area where our educational support programs are focused.`,
    author: 'Hagen-Family-Foundation',
    image: 'https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=800',
    tags: ['education', 'tacloban', 'teacher education'],
  },
];

export const getPostBySlug = (slug) => {
  return blogPosts.find(post => post.slug === slug);
};

export const getRecentPosts = (count = 5) => {
  return [...blogPosts].sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, count);
};
